/* 
APPLY TOOLTIP TO ALL ELEMENTS WITH DATA-TOOLTIP ATTRIBUTE
example : data-tooltip-info="{{ text_info }}"
*/

document.addEventListener("DOMContentLoaded", function() {
    const tooltipElements = document.querySelectorAll('[data-tooltip-info]');
    tooltipElements.forEach(tip => {
        tip.addEventListener('mouseover', () => {
            var tip_rect = tip.getBoundingClientRect();
            var tip_text = {
                width: tip.offsetWidth,
                height: (tip.offsetHeight + 100)
            };
            
            if ((tip_rect.y + tip_text.height) > window.innerHeight) {
                tip.classList.remove('display-bottom');
            } else{
                tip.classList.add('display-bottom');
            }
      });
    });
  });